import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { trackEventMatomo } from '../../helpers/matomo';
import { TabPanelProps } from "../../types/helpers/types";
import ListaEquipes from "./ListaEquipes";
import TeamRegister from "./TeamRegister";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TeamsTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('gestão de equipes', 'click', 'aba', newValue === 0 ? 'equipes cadastradas' : 'cadastro de equipe');
    setValue(newValue);
  };
  const { t } = useTranslation('translation');

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
        >
          <Tab value={0} label={t('teamManage.title')} />
          <Tab value={1} label={t('teamManage.register.title')} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ListaEquipes />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TeamRegister />
      </CustomTabPanel>
    </>
  );
}
